import { render, staticRenderFns } from "./airdetail.vue?vue&type=template&id=65c88b12&scoped=true"
import script from "./airdetail.vue?vue&type=script&lang=js"
export * from "./airdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c88b12",
  null
  
)

export default component.exports